import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { MeValidation } from './me-validation';
import { TranslateUtilityService } from 'src/app/system/utility/translation-utility.service';

export class MeRequiredValidation extends MeValidation {
  constructor(translate: TranslateService | TranslateUtilityService) {
    super(translate, 'required');
    this.validators = Validators.required;
  }

  getErrorMessage(): string {
    let errorMsg: string = 'MESSAGE_ERROR_REQUIRED';
    return this.translate.instant(errorMsg);
  }
}
